import { render, staticRenderFns } from "./OrderBumps.vue?vue&type=template&id=ce17c178"
import script from "./OrderBumps.vue?vue&type=script&lang=js"
export * from "./OrderBumps.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/maq/Code/skyier/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ce17c178')) {
      api.createRecord('ce17c178', component.options)
    } else {
      api.reload('ce17c178', component.options)
    }
    module.hot.accept("./OrderBumps.vue?vue&type=template&id=ce17c178", function () {
      api.rerender('ce17c178', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/checkout/components/single/OrderBumps.vue"
export default component.exports